var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotebookDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.571,
    viewBox: "0 0 16 12.571",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notebook",
    transform: "translate(18.25 18.196) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M21.375,11.25h2v1.143h-2Z",
    transform: "translate(-8.125 -2.768)",
    fill: "#5dc9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M21.375,16.875h2v1.143h-2Z",
    transform: "translate(-8.125 -5.536)",
    fill: "#5dc9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M21.375,22.5h2v1.143h-2Z",
    transform: "translate(-8.125 -8.304)",
    fill: "#5dc9f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M17.107,5.625H3.393A1.144,1.144,0,0,0,2.25,6.768V17.054A1.144,1.144,0,0,0,3.393,18.2H17.107a1.144,1.144,0,0,0,1.143-1.143V6.768A1.144,1.144,0,0,0,17.107,5.625ZM3.393,6.768h7.286V17.054H3.393Zm8.429,10.286V6.768h5.286V17.054Z",
    fill: "#5dc9f0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotebookDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notebook_dark.c1d878c91dfa6debd99c973f0ec3ca06.svg";